import axios from '../../utils/axios';

const getTotalVideos = async (tags, search, author = '') => {
    let queryString = '';

    if (tags?.length > 0) {
        queryString += tags.map((tag) => `tags_like=${tag}`).join('&');
    }

    if (search !== '') {
        queryString += `&q=${search}`;
    }

    if (author !== '') {
        queryString += `&author_like=${author}`;
    }

    const response = await axios.get(`/videos/?${queryString}`);

    return response.data.length;
};

export default getTotalVideos;
